"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piacenza": {
    "43b58d7e": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "skipSearch": false
    }],
    "b-ra-genova": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "30f93209": [{
      "hkey": "e461b7dd",
      "slug": "infrangibile",
      "name": "Infrangibile",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d9bce156",
      "slug": "ospedale-via-taverna",
      "name": "Ospedale-Via Taverna",
      "primary": false,
      "skipSearch": false
    }],
    "b-ra-torino": [{
      "hkey": "e461b7dd",
      "slug": "infrangibile",
      "name": "Infrangibile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "201e4bd4": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "skipSearch": false
    }],
    "baia-del-re": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fe932a75": [{
      "hkey": "556b800e",
      "slug": "belvedere-clinica-piacenza",
      "name": "Belvedere-Clinica Piacenza",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "556b800e",
      "slug": "belvedere-clinica-piacenza",
      "name": "Belvedere-Clinica Piacenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8eb7b135": [{
      "hkey": "f5157da0",
      "slug": "cristoforo-colombo-farnesiana",
      "name": "Cristoforo Colombo-Farnesiana",
      "primary": true,
      "skipSearch": false
    }],
    "farnesiana": [{
      "hkey": "f5157da0",
      "slug": "cristoforo-colombo-farnesiana",
      "name": "Cristoforo Colombo-Farnesiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d79010c9": [{
      "hkey": "8b918092",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "p-zza-borgo": [{
      "hkey": "8b918092",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "8427a720": [{
      "hkey": "8b918092",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "p-zza-duomo": [{
      "hkey": "8b918092",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "7361a00e": [{
      "hkey": "4a22e8c4",
      "slug": "quartiere-2000-stadio",
      "name": "Quartiere 2000-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "quart-2000": [{
      "hkey": "4a22e8c4",
      "slug": "quartiere-2000-stadio",
      "name": "Quartiere 2000-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2036ba6e": [{
      "hkey": "556b800e",
      "slug": "belvedere-clinica-piacenza",
      "name": "Belvedere-Clinica Piacenza",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e461b7dd",
      "slug": "infrangibile",
      "name": "Infrangibile",
      "primary": false,
      "skipSearch": false
    }],
    "raffalda": [{
      "hkey": "556b800e",
      "slug": "belvedere-clinica-piacenza",
      "name": "Belvedere-Clinica Piacenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "5c51b546": [{
      "hkey": "0f568e18",
      "slug": "sant-antonio-veggioletta",
      "name": "Sant'Antonio-Veggioletta",
      "primary": true,
      "skipSearch": false
    }],
    "s-antonio": [{
      "hkey": "0f568e18",
      "slug": "sant-antonio-veggioletta",
      "name": "Sant'Antonio-Veggioletta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "08823e3a": [{
      "hkey": "d181587e",
      "slug": "san-lazzaro",
      "name": "San Lazzaro",
      "primary": true,
      "skipSearch": false
    }],
    "s-lazzaro": [{
      "hkey": "d181587e",
      "slug": "san-lazzaro",
      "name": "San Lazzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5f00dd96": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "skipSearch": false
    }],
    "viale-dante": [{
      "hkey": "96d58b32",
      "slug": "baia-del-re-dante-alighieri",
      "name": "Baia del Re-Dante Alighieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }],
    "68c1c32b": [{
      "hkey": "4a22e8c4",
      "slug": "quartiere-2000-stadio",
      "name": "Quartiere 2000-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "zona-stadio": [{
      "hkey": "4a22e8c4",
      "slug": "quartiere-2000-stadio",
      "name": "Quartiere 2000-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piacenza"
    }]
  }
};
exports["default"] = _default;